// src/redux/slice/tanProfilesSlice.js
import { createSlice, createSelector } from '@reduxjs/toolkit';
import { tanProfilesApi } from '../services/tanProfilesApi';
// import { component_id } from '../../components/componentMap/componentMap';
const stateTemplate = {
  profiles: {},
  components: {},
  selectedProfile: {
    session_component: []
  },
  mappedComponents: {},
  profileMeta: {
    profileType: null, //edit, new, booth, scanBooth
    sessionTypes: [], // tan, wellfit, tanfit
    options: [], //just an array of solution options, can be from booth inv
    navigationDirection: null // probably a better way to handle this, but oh well
  }, //just a catchall for profile stuff, used for defining the type of profile edit/selection occuring
  scannedBoothData: null,
  scannedBoothComponents: null
}
const tanProfilesSlice = createSlice({
  name: 'tanProfiles',
  initialState: stateTemplate,
  reducers: {
    fullResetProfile: (state, action) => {
      for(let item in stateTemplate){
        state[item] = stateTemplate[item]
      }
    },
    setSelected: (state, action) => {
      state.selectedProfile = action.payload;
    },
    setProfileMeta: (state, action) => {
      state.profileMeta = action.payload;
    },
    setTypes: (state, action) => {
      state.profileMeta.sessionTypes = action.payload;
    },
    setScannedBoothData: (state, action) => {
      state.scannedBoothData = action.payload;
    },
    setScannedBoothComponents: (state, action) => {
      state.scannedBoothComponents = action.payload;
    },
    removeComponent: (state, action) => {
      let currentComponents = state.selectedProfile.session_component

      const indexToRemove = currentComponents.findIndex(
        item => item.component_id === action.payload.component_id && item.component_value_id === action.payload.id
      );
      if (indexToRemove !== -1) {
        currentComponents.splice(indexToRemove, 1);
      }
      state.selectedProfile.session_component = currentComponents;
    },
    removeComponentsByName: (state, action) => {
      let currentComponents = state.selectedProfile.session_component
      let components = state.components
      console.log(components)
      const id = Object.values(components).find((item) => item.name === action.payload).id

      let indexToRemove = currentComponents.findIndex(item => item.component_id === id);
      while (indexToRemove > -1) {
        currentComponents.splice(indexToRemove, 1);
        indexToRemove = currentComponents.findIndex(item => item.component_id === id);
      }

      state.selectedProfile.session_component = currentComponents;
    },
    addComponent: (state, action) => {
      let currentComponents = state.selectedProfile.session_component
      currentComponents.push({
        "value": action.payload.value,
        "component_id": action.payload.component_id,
        "component_value_id": action.payload.id
      })
      state.selectedProfile.session_component = currentComponents;
    },
    setTan: (state, action) => {
      const level = action.payload.level
      const component = action.payload.component
      const component_value_id = action.payload.component_value_id
      let currentComponents = state.selectedProfile.session_component
      const existingTanIndex = currentComponents.findIndex((item) => item.component_id === component) //Don't @ me nerd
      const newLevel = {
        "value": level.toString(),
        "component_id": component,
        "component_value_id": component_value_id
      }
      if (existingTanIndex > -1) {
        currentComponents[existingTanIndex] = newLevel
      } else {
        currentComponents.push(newLevel)
      }
      state.selectedProfile.session_component = currentComponents;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(tanProfilesApi.endpoints.getTanProfiles.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.profiles[payload?.payload?.getAllProfileByUser?.current_page] = payload?.payload?.getAllProfileByUser;
      })
      .addMatcher(tanProfilesApi.endpoints.getTanProfiles.matchRejected, (state, { payload }) => {
        console.log(payload)
        state.profiles = {};
      })
      .addMatcher(tanProfilesApi.endpoints.getBoothPricing.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.scannedBoothComponents = payload?.payload?.components;
      })
      .addMatcher(tanProfilesApi.endpoints.getScannedBooth.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        state.scannedBoothData = payload?.payload;
        let mappedComponents = {}
        payload?.payload?.last_booth_state?.inventory.map((obj) => { 
          mappedComponents[obj.sku.toString()] = state.mappedComponents[obj.sku.toString()] && obj.is_valid && !obj.is_empty
        }) // Force available components to what's on booth
        state.mappedComponents = mappedComponents
      })
      .addMatcher(tanProfilesApi.endpoints.getComponents.matchFulfilled, (state, { payload }) => {
        console.log(payload)
        const timeStamp = new Date().getTime()
        let comps = payload?.payload?.components.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
        let obj = {}
        for (let product in comps) {
          for (let component in comps[product].component_values) {
            obj[comps[product].component_values[component].sku] = {
              name: comps[product].name,
              slug: comps[product].slug,
              // max: comps[product].max, 
              sku: comps[product].component_values[component].sku,
              componentValue: comps[product].component_values[component].value,
              id: comps[product].component_values[component].id,
              componentId: comps[product].component_values[component].component_id,
            }
          }
        }
        comps.timeStamp = timeStamp
        obj.timeStamp = timeStamp
        state.components = comps
        if(state.scannedBoothData?.last_booth_state){ // allways use booth inventory if available
          let mappedComponents = {}
          state.scannedBoothData?.last_booth_state?.inventory.map((item) => { 
            mappedComponents[item.sku.toString()] = obj[item.sku.toString()]
          }) // Force available components to what's on booth
        state.mappedComponents = mappedComponents
        }else{
          state.mappedComponents = obj
        }
      })
  },
});

export const getSessionOptions = createSelector(
  [(state) => state?.tanProfile],
  (tanProfile) => {
    const options = tanProfile?.profileMeta?.options
    let slugs = [];
    for (let i in options) {
      let option = tanProfile?.mappedComponents[options[i].sku];
      if (option?.slug && !options[i].is_empty && options[i].is_valid) {
        slugs.push(option.slug.toLowerCase());
      }
    }
    return {
      Tan: slugs.includes("base tan level") || slugs.includes("base") && 
      (slugs.includes("activator") || slugs.includes("developer")),
      Rapid: slugs.includes("rapid") && 
      (slugs.includes("activator") || slugs.includes("developer")),
      WellFit: slugs.includes("wellfit") && (slugs.includes("skincare base") || slugs.includes("wellfit base solution")),
      Moisturizer: slugs.includes("moisturizer"),
      Bronzer: slugs.includes("bronzers"),
      Scent: slugs.includes("scents"),
      Accelerator: slugs.includes("accelerator"),
    };
  }
);

export const getComponentsByName = createSelector(
  [(state) => state, (_, name) => name],  // First is state, second is the name parameter
  (state, name) => {
    let returnObj = Object.values(state?.tanProfile?.components).find(item => item.name === name)?.component_values
    if(returnObj){
      return returnObj.filter((item) => state?.tanProfile?.mappedComponents[item?.sku.toString()] && item.value !== "no")
    }
  }
);

export const getComponentsBySlug = createSelector(
  [(state) => state, (_, slug) => slug],  // First is state, second is the name parameter
  (state, slug) => {
    let returnObj = Object.values(state?.tanProfile?.components).find(item => item.slug === slug)?.component_values

    if(returnObj){
      if(state?.tanProfile?.scannedBoothData){
        return returnObj.filter((item) => state?.tanProfile?.mappedComponents[item?.sku.toString()] && item.value !== "no")
      }else{
        return returnObj.filter((item) => state?.tanProfile?.mappedComponents[item?.sku.toString()] && item.value !== "no" && item.price > 0)
      }
    }  
  }
);

export const getComponentById = createSelector(
  [(state) => state?.tanProfile?.selectedProfile?.session_component, (_, id) => id],  // First is state, second is the name parameter
  (components, id) => {
    return components.find((item) => item.component_id === id);
  }
);

export const getSessionComponentsPretty = createSelector(
  [(state) => state?.tanProfile, (_, id) => id],  // First is state, second is the name parameter
  (tanProfile, id) => {
    let compArr = []
    for (let i in tanProfile?.components) {
      for (let component in tanProfile?.components[i].component_values) {
        let component_id = tanProfile?.components[i].component_values[component].id
        const count = tanProfile?.selectedProfile?.session_component.filter(
          (item) => item.component_value_id === component_id
        ).length;
        if (count > 0)
          compArr.push({ ...tanProfile?.components[i].component_values[component], name: tanProfile?.components[i].name, count })
      }
    }
    return compArr;
  }
);

export const { fullResetProfile, setSelected, setProfileMeta, addComponent, removeComponent, setTan, setTypes, removeComponentsByName, setScannedBoothComponents, setScannedBoothData } = tanProfilesSlice.actions;
export default tanProfilesSlice.reducer;
